module.exports = __webpack_public_path__ + "img/sk.0396deac.svg";